import { IOptionDropdown } from "@/types/dropdown";
import { EContract } from "@/apps/merchant3/models/IStateContract";
import { IFeeSchema } from "@/apps/merchant3/types/FeesAndTaxes/IFeeSchema";
import { IPeruFeeSchema } from "@/apps/merchant3/types/FeesAndTaxes/PeruFeesAndTaxes";

export interface IModel {
  deviceModelId: string;
  makeModel: string;
  maxFinanceAmount?: string;
  maxFinancePercent?: string;
  minFinanceAmount?: string;
  modelSelect: string;
  retailPrice?: string;
  description?: string;
}

export interface IDeviceBrand {
  name: string;
  code: string;
  models: IModel[];
}

export interface IPricing {
  "3"?: IPaymentTerms;
  "6"?: IPaymentTerms;
  "9"?: IPaymentTerms;
  "12"?: IPaymentTerms;
}

export interface IFeeOrTaxComponentDTO {
  id: string;
  labelTranslationKey: string;
  value: string;
}

export interface IPaymentTerms {
  best?: number | null;
  creditLineEstimate?: ICreditLineEstimate | null;
  downPayment: number | string;
  feesAndTaxes?: IFeeSchema | null;
  offersFeesAndTaxesDTOs?: IFeeOrTaxComponentDTO[] | null;
  months: number;
  monthlyPayment: number;
  numberOfInstallments: number;
  paymentAmount: number;
  paymentFrequency: string;
  popularity?: string | null;
  totalAmount: number;
  weeks: number;
  weeklyPayment: number;
}

export interface ICreditLineEstimate {
  newMinimumPaymentAmount: number;
  minimumPaymentAmountForSimulatedDebit: number;
  currentMinimumPaymentAmount: number | null;
  totalPhonePrice: number;
}

export interface ICartWrap {
  cart: IStateCart;
}

export interface IStateCart {
  activationMethod?: string | null;
  activeFeatures?: string[] | null;
  allDevices: IDeviceBrand[];
  attempts: number;
  associatedCreditLineId?: number | null;
  cartId?: number;
  cartTag?: string | null;
  contractDecisionTime?: string | null;
  contractSignedTimestamp: string | null;
  termsAcceptedTimestamp?: string | null;
  acceptPrivacyTimestamp?: string | null;
  creditCheckPermittedTimestamp?: string | null;
  creditCheckPermissionType?: string | null;
  creditLineEstimate?: ICreditLineEstimate | null;
  contractVerballyAccepted: EContract;
  cost30?: number | null;
  cost7?: number | null;
  createTime: number | string;
  currentPage: string | "";
  customerTag: string;
  deviceBrands: IDeviceBrand[];
  deviceFamilyId?: string;
  deviceFamilyName?: string;
  deviceidentifier: string;
  deviceImageUrl?: string | null;
  deviceModelId?: number | null;
  devicePhoneNumber?: string | null;
  deviceTag: string;
  downPayment?: number | null;
  feeSchema?: IPeruFeeSchema | unknown | null;
  financeAmount?: number | null;
  friendlyDeviceName?: string;
  friendlyFamilyName?: string;
  hasReceivedWelcomeCall: EContract;
  imei?: string | number | null;
  lastPersonRegistrationTag: string | null;
  lastUpdate: number | string;
  manufacturer: string | null;
  merchantId: number;
  months?: number | null;
  newPhoneNumber?: string | null;
  oneTimePassword?: IOneTimePasswordResult | null;
  personRegistrationTag?: string | null;
  priceWithSalesTax?: number | null;
  pricing?: IPricing | null;
  promoCode?: string | null;
  retailPrice?: number | null;
  salesClerkId: number;
  salestax?: number | null;
  securityDeposit?: number | null;
  selectedBrand: IDeviceBrand[];
  selectedBrandCode: string | null;
  selectedBrandName: string | null;
  selectedDeviceModels: IModel[];
  selectedDeviceModelsDropdown: IOptionDropdown[];
  selectedImageUrl: string | null;
  selectedModel: IDeviceBrand[];
  selectedModelCode: string | null;
  selectedModelName: string | null;
  step?: string | null;
  canceledReason?: string | null;
  selectedOffer: number | null;
  serialNumber: string;
  userId?: number | null;
  userTag?: string | null;
  welcomeCallRequired?: EContract | null;
  incodeOnboardComplete?: boolean | null;
  incodeOnboardStatus?: string | null;
  productVersion: string;
  experiments?: ICartExperiments;
  associatedFinanceOrderId?: number | null;
  welcomeCallAttempts?: number | null;
  deviceVariantName?: string | null;
  uniqueRequestList?: string[];
  ssaa?: boolean;
}

export interface IBadge {
  badgeType: IBadgeExperiments;
  badgeValue: number;
}

export interface ICartExperiments {
  LowerWeeklyPaymentBadges?: boolean;
  noPaymentBadge?: boolean;
  monthTermPopularityBadges?: boolean;
  LowestTotalPaymentBadge?: boolean;
  promoDPExperiment?: boolean;
  offersPreRegistration?: boolean;
  phoneSelfieRequired?: boolean;
  noModalContractPageExperiment?: boolean;
  InConsoleTraining?: boolean;
}

export enum IBadgeExperiments {
  LOWER_WEEKLY_PAYMENT_BADGES = "LowerWeeklyPaymentBadges",
  NO_PAYMENT_BADGE = "noPaymentBadge",
  MONTH_TERM_POPULARITY_BADGES = "monthTermPopularityBadges",
  LOWEST_TOTAL_PAYMENT_BADGE = "LowestTotalPaymentBadge",
}

interface IOneTimePasswordResult {
  balance?: number | null;
  oneTimePassword?: string | null;
}
